import clsx from 'clsx'
import { GalleryWideBlock } from '../../@types/statamic'
import { PageInfo } from '@/src/@types/models'
import Picture from '@/src/components/elements/Picture'

export function getImage({ images }: GalleryWideBlock) {
  return images[0]
}

export default function Component({
  images,
  pageInfo,
}: GalleryWideBlock & {
  pageInfo: PageInfo
}) {
  return (
    <div
      className={clsx({
        'mt-20 md:mt-32': pageInfo.newSpacing,
      })}
    >
      <div className="grid grid-cols-2 gap-4 md:hidden">
        <div className="relative h-45.5">
          <Picture
            {...images[1]}
            sizes="(min-width: 768px) 25vw, 50vw"
            fill
            className="rounded-r-lg object-cover"
          />
        </div>
        <div className="relative h-45.5">
          <Picture
            {...images[2]}
            sizes="(min-width: 768px) 25vw, 50vw"
            fill
            className="rounded-l-lg object-cover"
          />
        </div>
        <div className="relative col-span-2 row-span-2 h-95">
          <Picture
            {...images[0]}
            sizes="(min-width: 768px) 50vw, 100vw"
            fill
            className="object-cover"
          />
        </div>
      </div>
      <div className="@container mx-auto hidden max-w-436 grid-cols-4 gap-8 md:grid">
        <div className="relative col-span-2 row-span-3 h-200">
          <Picture
            {...images[0]}
            sizes="(min-width: 768px) 50vw, 100vw"
            fill
            className="rounded-r-2xl object-cover @min-[1744px]:rounded-2xl"
          />
        </div>
        <div className="relative">
          <Picture
            {...images[2]}
            sizes="(min-width: 768px) 25vw, 50vw"
            fill
            className="rounded-2xl object-cover"
          />
        </div>
        <div className="relative">
          <Picture
            {...images[3]}
            sizes="(min-width: 768px) 25vw, 50vw"
            fill
            className="rounded-l-2xl object-cover @min-[1744px]:rounded-2xl"
          />
        </div>
        <div className="relative col-span-2 row-span-2">
          <Picture
            {...images[1]}
            sizes="(min-width: 768px) 50vw, 100vw"
            fill
            className="rounded-l-2xl object-cover @min-[1744px]:rounded-2xl"
          />
        </div>
      </div>
    </div>
  )
}
